import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `ACCT-LEAVE-GROUP` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/settings` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 12 — cụm tài khoản: rời nhóm. `FinancialPositionService` là nguồn chặn (§3.6), và `RECIPROCAL_*` KHÔNG tính là nợ nên người còn 'nợ đáp lễ' vẫn rời được).
 */
export const ACCT_LEAVE_GROUP = {
  id: "ACCT-LEAVE-GROUP",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    /*
     * 🔴 US-AIV2-0110 S11 (@UC0273) — câu `known-intent-gaps` `"huỷ tham gia nhóm"` ⇒ JOIN-REQUEST-MINE (conf 0,62, đo 24/09):
     * mô tả cũ không nói ranh giới với trang đó. Cả hai trang mọi vai đều thấy ⇒ ranh giới đặt Ở ĐÂY được.
     * ⚠️ Câu còn lại của trang này (`"bo nhom"` ⇒ GRP-ARCHIVE-DELETE) KHÔNG đặt ranh giới ở đây: GRP-ARCHIVE-DELETE chỉ trưởng
     * nhóm thấy, nhắc id của nó trong mô tả trang THÀNH VIÊN cũng thấy là đưa một trang họ không được chọn vào prompt của họ
     * (cùng họ `@UC0152`). Ranh giới ấy nằm ở `grp-archive-delete.ts` — chỉ người thấy cả hai trang mới cần nó.
     */
    description:
      "Rời khỏi một nhóm mà bạn đang tham gia, khi bạn không còn đóng góp cho quỹ của nhóm đó nữa. Chủ ngữ là CHÍNH NGƯỜI HỎI rời đi: \"huỷ tham gia nhóm\" / \"huy tham gia nhom\" là rời nhóm đang ở — chỉ rút lại lời xin vào một nhóm CHƯA được duyệt mới là JOIN-REQUEST-MINE.",
    examples: [
      "tôi muốn rời nhóm",
      "toi muon roi nhom",
      "thoát nhóm này",
      "thoat nhom nay",
      "rời nhóm",
      "out nhóm",
      // ——— 0105: thêm cho đủ 40 ———
      "cho tôi rời nhóm này",
      "cho toi roi nhom nay",
      "mình xin rút khỏi nhóm",
      "minh xin rut khoi nhom",
      "rút khỏi nhóm quỹ lớp",
      "rut khoi nhom quy lop",
      "không tham gia nhóm nữa",
      "khong tham gia nhom nua",
      "tôi nghỉ nhóm nhé",
      "toi nghi nhom nhe",
      "muốn thoát ra khỏi nhóm thì làm sao",
      "muon thoat ra khoi nhom thi lam sao",
      "rời nhóm kiểu gì?",
      "roi nhom kieu gi",
      "bỏ nhóm",
      "bo nhom",
      "con tôi chuyển lớp rồi, mình muốn rời nhóm",
      "con toi chuyen lop roi minh muon roi nhom",
      "tôi không đóng quỹ nữa, cho rời nhóm",
      "toi khong dong quy nua cho roi nhom",
      "rời khỏi đội bóng công ty",
      "roi khoi doi bong cong ty",
      "xin phép rời nhóm hội đồng hương",
      "xin phep roi nhom hoi dong huong",
      "thoát",
      "tôi muốn ra khỏi nhóm này",
      "toi muon ra khoi nhom nay",
      "huỷ tham gia nhóm",
      "huy tham gia nhom",
      "cho mình out",
      "cho minh out",
      "leave group",
      "tôi rời đây",
      "toi roi day",
      "nghỉ chơi nhóm này nhé",
      "chuyển nhà rồi nên xin rời nhóm",
      "chuyen nha roi nen xin roi nhom",
    ],
  },
  screen: "/groups/:groupId/settings",
  screenShows: "leave_group",
  endpoints: [
    "DELETE /groups/{groupId}/membership",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở cài đặt nhóm để bạn rời nhóm nhé. Nếu bạn còn khoản chưa đóng hoặc nhóm còn nợ bạn, hệ thống sẽ nói rõ trước khi cho rời.",
  },
  journey: { after: ["GRP-OPEN"] },
  help: { title: "Rời nhóm", tryNow: "tôi muốn rời nhóm" },
} satisfies AiCapabilityPage;
